import React, { useState } from 'react';

import styled from 'styled-components';

import ShopDataModalContractsModal from './ShopDataModalContractsModal';
import { useContractContext } from '../../../common/Contract/ContractContext';
import ShopDataModalAddButtonPill from '../common/ShopDataModalAddButtonPill';
import { useShopDataModalContext } from '../ShopDataModalContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px;
`;

const Label = styled.span`
  font-size: 18px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  margin-bottom: 6px;
`;

const Description = styled.span`
  font-size: 14px;
  color: var(--gray-dark);
  margin-bottom: 10px;
`;

interface Props {
  categories: string[];
}

const ShopDataModalAddContracts = ({ categories }: Props) => {
  const { currentLivingType, community, currentData, setCurrentData } = useShopDataModalContext();
  const { setSelectedKey } = useContractContext();
  const [open, setOpen] = useState<boolean>(false);

  const handleAddContractType = () => {
    setOpen(true);
  };

  const handleConfirmContract = (contracts: string[]) => {
    const livingTypeKey = String(currentLivingType?.abv);

    const contractKey = contracts.join('|');
    const updates = categories.reduce((acc, fieldCategoryKey: string) => {
      return {
        ...acc,
        [fieldCategoryKey]: {
          ...(currentData[fieldCategoryKey] || {}),
          [livingTypeKey]: {
            ...(currentData[fieldCategoryKey]?.[livingTypeKey] || {}),
            [contractKey]: {},
          },
        },
      };
    }, {});

    setCurrentData((prevState: any) => ({
      ...prevState,
      ...updates,
    }));
    setSelectedKey(contractKey);
  };

  return (
    <Container>
      <Label>No contract types selected.</Label>
      <Description>Use the button below to select contract types to add data for.</Description>
      <ShopDataModalAddButtonPill
        className={'borderless'}
        label={'Select Contract Types'}
        onClick={handleAddContractType}
        dataTestId='select-contracts-type-btn'
      />
      {open && (
        <ShopDataModalContractsModal
          open={open}
          contractOptions={community?.contracts || []}
          onConfirm={handleConfirmContract}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
    </Container>
  );
};

export default ShopDataModalAddContracts;
